import React from 'react';

const STEPS = [
  { n: 1, label: 'Proceso' },
  { n: 2, label: 'Datos Personales' },
  { n: 3, label: 'Requisitos' },
];

export default function StepsBar({ currentStep, onBack }) {
  return (
    <div className="hero">
      <div className="hero-inner">
        <div className="hero-badge">Inscripción de Postulantes</div>
        <h1 className="hero-title">Portal de Admisión EPG</h1>
        <p className="hero-sub">Complete los pasos para registrar su postulación</p>
        <div className="steps-bar">
          {currentStep > 1 && (
            <button className="btn-back-hero" onClick={onBack} title="Paso anterior">
              ← Atrás
            </button>
          )}
          {STEPS.map((s, i) => {
            const done = currentStep > s.n;
            const active = currentStep === s.n;
            return (
              <React.Fragment key={s.n}>
                <div className={`step ${active ? 'active' : ''} ${done ? 'done' : ''}`}>
                  <div className="step-circle">
                    {done ? '✓' : s.n}
                  </div>
                  <div className="step-label">{s.label}</div>
                </div>
                {i < STEPS.length - 1 && (
                  <div className={`step-line ${done ? 'done' : ''}`} />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
}
